import React from "react";
import Grid from "@mui/material/Grid";

export const Row = ({ children, ...props }) => (
    <Grid container spacing={2} {...props}>{children}</Grid>
);
export default Row;